




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import Counter from '@/components/commons/Counter.vue';
import SelectBoolean from '@/components/commons/SelectBoolean.vue';
import { default as axios } from 'axios';
import {
  GardenCollectInterface,
  GardenSummaryInterface,
} from '@/interfaces/garden/garden.interface';
import { Utils } from '../../utils/utils';

@Component({
  components: { Counter, SelectBoolean },
})
export default class GardenCollect extends Vue {
  public dialog: boolean = false;
  public iconResult: string = '';
  public explainationError: string = '';
  public eggsCount: number = 0;
  public disableBtn: boolean = false;

  private wateringDone: boolean = false;
  private horsesDone: boolean = false;
  private courgetteNumber: number = -1;
  private tankLevel: number = -1;

  private setGardenCollect(): GardenCollectInterface {
    const user: string = Utils.getCurrentUserName();
    const summary: GardenSummaryInterface[] = new Array();
    summary.push({
      action: 'Arrosage de la serre',
      type: 'boolean',
      value: this.wateringDone,
      unit: '',
    });
    summary.push({
      action: 'Abreuvoir des chevaux',
      type: 'boolean',
      value: this.horsesDone,
      unit: '',
    });
    summary.push({
      action: 'Niveau de la cuve',
      type: 'number',
      value: this.tankLevel === -1 ? NaN : this.tankLevel,
      unit: 'L',
    });
    summary.push({
      action: 'Courgettes récupérées',
      type: 'number',
      value: this.courgetteNumber === -1 ? NaN : this.courgetteNumber,
      unit: '',
    });

    const gardenCollect: GardenCollectInterface = {
      user,
      date: new Date(),
      summary,
    };

    return gardenCollect;
  }

  public signalCollect() {
    const user: string = Utils.getCurrentUserName();
    this.disableBtn = true;
    const data: GardenCollectInterface = this.setGardenCollect();
    axios
      .post(`${process.env.VUE_APP_API_URL}/gardens`, data)
      .then(response => {
        this.iconResult = 'fa fa-thumbs-up';
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      })
      .catch(err => {
        this.iconResult = 'fa fa-exclamation-triangle';
        this.explainationError = err;
      });
  }
}
